(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/ripple-effect/assets/javascripts/ripple-effect.js') >= 0) return;  svs.modules.push('/components/components/ripple-effect/assets/javascripts/ripple-effect.js'); "use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }


(function (svs, window, gsap) {
  'use strict';

  svs = svs || {};
  svs.components = svs.components || {};

  svs.components.RippleEffect = function () {
    function _class(el, callback) {
      _classCallCheck(this, _class);

      if (el instanceof jQuery) {
        this.el = el.get(0);
      } else if (el instanceof HTMLElement) {
        this.el = el;
      } else {
        this.el = document.querySelector(el);
      }

      if (callback) {
        this.cb = callback;
      }

      this.init();
    }

    _createClass(_class, [{
      key: "init",
      value: function init() {
        var _this = this;

        var rippleEffectTiming = 0.5;
        var cbHasBeenCalled = false;
        var ripple;

        this.el.onmousedown = function () {
          if (!ripple) {
            ripple = document.createElement('span');
          }

          cbHasBeenCalled = false;
          var backgroundColor = window.getComputedStyle(_this.el).getPropertyValue('background-color');
          var backgroundIsDark = backgroundColor === 'rgba(0, 0, 0, 0)' ? false : _this.isDark(backgroundColor);

          _this.el.classList.add('ripple');

          if (!backgroundIsDark) {
            _this.el.className += ' ripple-inverted';
          }
        };

        this.el.onmouseup = function (e) {
          if (ripple) {
            var rect = _this.el.getBoundingClientRect();

            var win = _this.el.ownerDocument.defaultView;
            var x = e.pageX - (rect.left + win.pageXOffset);
            var y = e.pageY - (rect.top + win.pageYOffset);
            var w = _this.el.offsetWidth * 1.1;
            ripple.className = 'ripple-effect';
            ripple.style.left = "".concat(x, "px");
            ripple.style.top = "".concat(y, "px");

            _this.el.appendChild(ripple);

            gsap.fromTo(ripple, {
              scale: 1,
              opacity: 1
            }, {
              duration: rippleEffectTiming,
              scale: w,
              opacity: 0,
              ease: 'power0.inOut',
              onComplete: function onComplete() {
                if (ripple) {
                  if (_this.el.contains(ripple)) {
                    _this.el.removeChild(ripple);
                  }

                  _this.el.classList.remove('ripple', 'ripple-inverted');

                  ripple = null;
                }
              }
            }); 

            if (_this.cb) {
              setTimeout(function () {
                if (!cbHasBeenCalled) {
                  _this.cb(e);
                }

                cbHasBeenCalled = true;
              }, rippleEffectTiming * 1000 - 100);
            }
          }
        };
      }
    }, {
      key: "isDark",
      value: function isDark(color) {
        var b;
        var g;
        var r;

        if (color.match(/^rgb/)) {
          color = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);
          r = color[1];
          g = color[2];
          b = color[3];
        } else {
          color = Number("0x".concat(color.slice(1).replace(color.length < 5 && /./g, '$&$&')));
          r = color >> 16;
          g = color >> 8 & 255;
          b = color & 255;
        }

        var hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));

        if (hsp > 200) {
          return false;
        }

        return true;
      }
    }]);

    return _class;
  }();
})(svs, window, gsap);
 })(window);